import menuList from "../menu/menu2";
import store from "../store";
// 将菜单集合放入store
store.commit("setMenuList", menuList);

/**
 * 递归注册路由
 */
function routeRegister(menuList, parentPath) {
  // 初始化父路由
  parentPath || (parentPath = "");
  let routes = [];
  menuList.forEach((menu) => {
    let routeItem = {
      ...menu,
    };
    // 父路由路径
    routeItem.path = `${parentPath.toLowerCase()}/${routeItem.name.toLowerCase()}`;
    // 递归处理子路由
    let children = menu.children;
    children && (routeItem.children = routeRegister(children, routeItem.path));
    routes.push(routeHandler(routeItem));
  });
  return routes;
}

/**
 * 路由处理器
 */
function routeHandler({ path, name, title, children }) {
  return {
    path,
    //不指定name 无法传递params
    name,
    component: components[name],
    meta: {
      title,
    },
    props: true,
    children: children || [],
  };
}

/**
 * 页面组件
 */
const components = {
  INDEX: () => import(`@v/Index2.vue`),
  MAIN_MENU: () => import("@v/MainMenu.vue"),
  PRODUCTION_CENTER: () => import(`@v/productionCenter/Index.vue`),

  // 吹膜工单
  STATION_WORK: () =>
    import(`@v/productionCenter/filmBlowingWorkOrder/Index.vue`),
  // 普通工单
  MASS_PRODUCTION: () =>
    import(`@v/productionCenter/standardWorkOrder/Index.vue`),
  // 待分配工单
  TRANSFER_DISPATCH: () =>
    import("@v/productionCenter/pendingAssignmentWorkOrder/Index.vue"),
  // 制袋工序
  PPI_MANAGE: () => import(`@v/productionCenter/bagMakingProcess/Index.vue`),
  // 印刷
  API_MANAGE: () => import(`@v/productionCenter/printing/Index.vue`),
  //压花抽边
  STATION_TEAMWORK: () =>
    import(`@v/productionCenter/embossingAndEdgeTrimming/Index.vue`),
  //膜卷分卷打印
  AGING_TEAMWORK: () =>
    import(`@v/productionCenter/filmRollSlitting/Index.vue`),
  //覆膜工单
  EDM_DOCUMENT: () =>
    import(`@v/productionCenter/laminationWorkOrder/Index.vue`),
  //质检执行
  PLM_DOCUMENT: () => import(`@v/productionCenter/qualityInspection/Index.vue`),
  //订单查询
  INSPECT_FIRST_ASSEMBLY_LINE: () =>
    import(`@v/productionCenter/order/Index.vue`),
};

//主页路由
const indexRoute = routeHandler({
  path: "/index",
  name: "INDEX",
  title: "主页",
  // 递归注册菜单路由
  children: routeRegister(menuList),
});

// 配置路由
let routes = [
  // 无效路由重定向
  {
    path: "*",
    redirect: indexRoute.path,
    props: true,
  },
  {
    path: "/login",
    name: "LOGIN",
    component: () => import(`../views/Login.vue`),
    meta: {
      title: "登录",
    },
  },
  indexRoute,
];

export default routes;
